import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import {  getCashesURL } from '../utils/api';

const useGetCashes = ({ 
        page = 1,
        limit = 3000,
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingCashes, setGettingCashes ] = useState(false);
    const [ cashes, setCashes ] = useState([]);
    const [ totalCashes, setTotalCashes ] = useState(0);
    const [ gettingCashesReqSuccess, setGettingCashesReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingCashes) {
            axios.get(getCashesURL,
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
                params: {
                    page,
                    limit,
                }
            }).then(result => {
                setGettingCashes(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    if (result.data.total) {
                        setTotalCashes(result.data.total);
                    }
                    setGettingCashesReqSuccess(true);
                    setCashes(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingCashesReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingCashesReqSuccess(false);
                setGettingCashes(false);
            });
        }
    }, [gettingCashes]);

    return { cashes, totalCashes, gettingCashes, setGettingCashes, gettingCashesReqSuccess };
}

export default useGetCashes;